(() => {
  if (window.__everideCartDrawerV2Ready) return;
  window.__everideCartDrawerV2Ready = true;

  const upgradeCartDrawer = () => {
    const drawer = document.querySelector('theme-drawer#cart-drawer');
    if (!drawer) return;

    // Horizon's theme-drawer uses this attribute to choose showModal()
    // and skip its desktop PageWrapper squeeze behavior.
    if (!drawer.hasAttribute('overlay')) drawer.setAttribute('overlay', '');

    // Defensive cleanup if an older squeeze state was restored before this script ran.
    const pageWrapper = document.querySelector('#PageWrapper');
    if (pageWrapper) {
      pageWrapper.classList.remove('drawer-open');
      pageWrapper.style.removeProperty('--drawer-squeeze-width');
    }
    document.documentElement.style.removeProperty('--drawer-squeeze-width');
  };

  const init = () => {
    upgradeCartDrawer();

    document.addEventListener('shopify:section:load', upgradeCartDrawer);
    document.addEventListener('cart:update', upgradeCartDrawer);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
